import { render, staticRenderFns } from "./AbkQuestion.vue?vue&type=template&id=351bff0c&scoped=true&"
import script from "./AbkQuestion.vue?vue&type=script&lang=js&"
export * from "./AbkQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AbkQuestion.vue?vue&type=style&index=0&id=351bff0c&lang=scss&scoped=true&"
import style1 from "./AbkQuestion.vue?vue&type=style&index=1&id=351bff0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351bff0c",
  null
  
)

export default component.exports